import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { html } from 'htm/preact';

const algoliaAppId = process.env.MIX_ALGOLIA_APP_ID;
const algoliaSecret = process.env.MIX_ALGOLIA_SECRET;

const locale = document.documentElement.lang || 'en';
const labels = {
  products: locale === 'fr' ? 'Produits' : 'Products',
  brands: locale === 'fr' ? 'Marques' : 'Brands',
  categories: locale === 'fr' ? 'Catégories' : 'Categories',
};
const placeholderImg = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Crect fill='%23f0f0f0' width='40' height='40'/%3E%3Cpath fill='%23ccc' d='M15 12h10v2H15zM12 18h16v2H12zM14 24h12v2H14z'/%3E%3C/svg%3E";

function trackEvent(category, action, name, value) {
  if (typeof _paq !== 'undefined') {
    const event = ['trackEvent', category, action, name];
    if (value) {
      event.push(value);
    }
    _paq.push(event);
  }
}

// Vérifier que l'élément autocomplete existe avant d'initialiser
// (et que l'appId Algolia est bien injecté au build — sinon algoliasearch() throw
// et casse tout le bundle front.js, dont window.bootstrap.Modal)
const autocompleteContainer = document.querySelector('#autocomplete');
if (autocompleteContainer && algoliaAppId) {
  const searchClient = algoliasearch(algoliaAppId, algoliaSecret);
  const search = autocomplete({
    container: '#autocomplete',
    onSelect({ item, source, state }) {
      trackEvent('search', 'click', source.sourceId, item.objectID || item.id);
      trackEvent('search', 'submit', 'autocomplete', state.query);
    },
  getSources({ query }) {
    return [
      {
        sourceId: 'products',
        getItemUrl({ item }) {
          return item.url;
        },
        getItems() {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: process.env.MIX_SCOUT_PREFIX + 'products',
                query,
                params: {
                  filters: 'tenants:"' + TENANT_ID + '"',
                  hitsPerPage: 4,
                },
              },
            ],
          });
        },
        templates: {
          header() {
            return html`<div class="aa-SourceHeader px-2 py-1 text-muted text-uppercase fw-bold" style="font-size:0.7rem;">${labels.products}</div>`;
          },
          item({ item }) {
            return html`
              <a href="${item.url}" class="w-100 d-flex align-items-center px-2 small">
                  <img src="${item.picture || placeholderImg}" class="me-2 rounded" style="width:40px;min-width:40px;height:40px;object-fit:contain;" />
                  <div>
                      ${item.brand_name ? html`<div class="text-muted text-uppercase" style="font-size:0.7rem;">${item.brand_name}</div>` : ''}
                      <div class="text-dark">${item.name}</div>
                  </div>
              </a>
            `;
          },
        },
      },
      {
        sourceId: 'teams',
        getItemUrl({ item }) {
          return item.url;
        },
        getItems() {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: process.env.MIX_SCOUT_PREFIX + 'teams',
                query,
                params: {
                  filters: 'tenants:"' + TENANT_ID + '" AND active:true',
                  hitsPerPage: 3,
                },
              },
            ],
          });
        },
        templates: {
          header() {
            return html`<div class="aa-SourceHeader px-2 py-1 text-muted text-uppercase fw-bold" style="font-size:0.7rem;">${labels.brands}</div>`;
          },
          item({ item }) {
            return html`
              <a href="${item.url}" class="w-100 d-flex align-items-center px-2 small">
                  <div class="text-dark">${item.name}</div>
              </a>
            `;
          },
        },
      },
      {
        sourceId: 'categories',
        getItemUrl({ item }) {
          return item.url;
        },
        getItems() {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: process.env.MIX_SCOUT_PREFIX + 'categories',
                query,
                params: {
                  filters: 'tenants:"' + TENANT_ID + '"',
                  hitsPerPage: 3,
                },
              },
            ],
          });
        },
        templates: {
          header() {
            return html`<div class="aa-SourceHeader px-2 py-1 text-muted text-uppercase fw-bold" style="font-size:0.7rem;">${labels.categories}</div>`;
          },
          item({ item }) {
            return html`
              <a href="${item.url}" class="w-100 d-flex align-items-center px-2 small">
                  <div>
                      ${item.themes && item.themes[1] ? html`<div class="text-muted text-uppercase" style="font-size:0.7rem;">${item.themes[1]}</div>` : ''}
                      <div class="text-dark">${item.name}</div>
                  </div>
              </a>
            `;
          },
        },
      },
    ];
  },
  });
}

// // Create a render function
// const renderSearchBox = (renderOptions, isFirstRender) => {
//   const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

//   if (isFirstRender) {
//     const input = document.createElement('input');

//     const loadingIndicator = document.createElement('span');
//     loadingIndicator.textContent = 'Loading...';

//     const button = document.createElement('button');
//     button.textContent = 'X';

//     input.addEventListener('input', event => {
//       refine(event.target.value);
//     });

//     button.addEventListener('click', () => {
//       clear();
//     });

//     widgetParams.container.appendChild(input);
//     widgetParams.container.appendChild(loadingIndicator);
//     widgetParams.container.appendChild(button);
//   }

//   widgetParams.container.querySelector('input').value = query;
//   widgetParams.container.querySelector('span').hidden = !isSearchStalled;
// };

